import { render, staticRenderFns } from "./virtual-tour.vue?vue&type=template&id=1ca2f621&scoped=true&"
import script from "./virtual-tour.vue?vue&type=script&lang=js&"
export * from "./virtual-tour.vue?vue&type=script&lang=js&"
import style0 from "./virtual-tour.vue?vue&type=style&index=0&id=1ca2f621&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca2f621",
  null
  
)

export default component.exports